/**
 * Enumerador para los estados del turno
 * @readonly
 * @enum {{descripcion: string, id: string}}
 */
 export const enumEstadoTurno = Object.freeze({
    ACTIVO:     { descripcion: "Activo", id: 1 },
    ASISTIO:    { descripcion: "Asistió", id: 2 },
    NO_ASISTIO: { descripcion: "No asistió", id: 8 },
    ANULADO:    { descripcion: "Anulado", id: 3 }
});